<template>
  <div class="pushInto">
    <new-task-modal
      class="import-modal"
      :newModalVisible="importModal"
      :closeonclickmodal="closeonclickmodal"
      @closeNewTask="closeImport"
      @addNewTask="nextStep"
      :agreeBtn="'导入'"
      :modalTitle="modalTitle"
      :showModalClose='!showLoading'
      :isDisabled="showLoading"
    >
      <div slot="content" style="text-align: left" v-loading="showLoading" element-loading-text="上传文件中"
    element-loading-spinner="el-icon-loading">
        <el-form
          :model="ruleFormImport"
          :rules="rulesImport"
          ref="ruleForm"
          label-width="110px"
          @validate="validateValue"
          :show-message="false"
        >
          <el-form-item label="上传文件" prop="isfile">
            <el-upload
              v-model="ruleFormImport.isfile"
              ref="upload"
              class="import-upload-file"
              accept=".zip"
              action="noUse"
              :data="uplodeDate"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :on-error="handleError"
              :before-remove="beforeRemove"
              :http-request="uploadSectionFile"
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="ruleFormImport.fileList"
            >
              <el-button class="import-btn" type="default" icon="el-icon-upload2">点击上传</el-button>
              <div slot="tip" class="import-upload-tip">200M以内，请上传照片压缩包，支持.zip</div>
              <!-- <div slot="tip" class="import-upload-tip" style="color:red">将人脸照片数据放入自定义文件夹,并对该文件夹进行压缩再上传</div> -->
            </el-upload>
          </el-form-item>
          <!-- <el-form-item v-if="!isSupplement" :label="(isSupplement?'':'') + '上传照片的命名规则'" prop="namingRule ">
            <el-radio-group
              v-model="ruleFormImport.namingRule"
              class="import-radio"
            >
              <el-radio :label="1">身份证号</el-radio>
              <el-radio :label="2">考生号</el-radio>
              <el-radio :label="3">学号</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="上传照片的命名规则"  prop="namingRule">
            <el-radio-group
              v-model="ruleFormImport.namingRule"
              v-if="identity == 'NEW_STUDENT'"
            >
              <el-radio :label="1">证件号码</el-radio>
              <el-radio :label="2">考生号</el-radio>
              <el-radio :label="3">学号</el-radio>
            </el-radio-group>
            <el-radio-group v-model="ruleFormImport.namingRule" v-if="identity == 'STUDENT'">
              <el-radio :label="1">证件号码</el-radio>
              <el-radio :label="3">学号</el-radio>
            </el-radio-group>
            <el-radio-group
              v-model="ruleFormImport.namingRule"
              v-if="identity == 'GRADUATE_STUDENT'"
            >
              <el-radio :label="1">证件号码</el-radio>
              <el-radio :label="3">学号</el-radio>
            </el-radio-group>
            <el-radio-group v-model="ruleFormImport.namingRule" v-if="identity == 'TEACHER'">
              <el-radio :label="1">证件号码</el-radio>
              <el-radio :label="3">工号</el-radio>
            </el-radio-group>
            <el-radio-group v-model="ruleFormImport.namingRule" v-if="identity == 'OTHER'">
              <el-radio :label="3">账号</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="!isSupplement" :label="(isSupplement?'':'') + '重复规则'" prop="gzRadio">
            <el-radio-group
              v-model="ruleFormImport.gzRadio"
              class="import-radio"
              @change="chickCF(ruleFormImport.gzRadio)"
            >
              <el-radio :label="1">覆盖重复照片</el-radio>
              <el-radio :label="2">跳过重复照片</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item :label="(isSupplement?'':'') + '错误规则'" prop="cwRadio">
            <el-radio-group
              v-model="ruleFormImport.cwRadio"
              class="import-radio"
            >
              <el-radio :label="1">跳过并继续</el-radio>
              <el-radio :label="2">中断并回滚</el-radio>
            </el-radio-group>
          </el-form-item> -->

          <div
            v-if="ruleFormImport.gzRadio == 3 && isOnly !==''"
            class="push-notice"
          >主键字段“{{isOnly}}”，不可重复，其余字段具体内容均可重复</div>
        </el-form>
      </div>
    </new-task-modal>
     <new-task-modal
      class="detail-modal new-transfer-modal push-transferBody"
      :closeonclickmodal="closeonclickmodal"
      :showModalClose='false'
      :newModalVisible="detailModal"
      @closeNewTask="closeDetail"
      @addNewTask="isdaoru"
      @cancelEvent="closeImport"
      :isChangelastStep="true"
      :isLast="haveLast"
      agreeBtn="确定导入"
      modalTitle="批量导入"
      @LastStep="LastTask"
    >
      <div slot="content">
        <new-transfer
          :isClose="isClose"
          :systematicRadio="systematicList"
          :excelRadio="excelList"
          :relationCheckbox="relationList"
        ></new-transfer>
      </div>
    </new-task-modal>
    <new-task-modal
      :showModalClose='!guanbiDisabled'
      class="output-modal"
      :closeonclickmodal="closeonclickmodal"
      :newModalVisible="daoruGuoCModal"
      @addNewTask="isdaoruGuoC"
      @closeNewTask="isdaoruGuoC"
      :isOneBtn="OnlyBtn"
      :isDisabled="guanbiDisabled"
      agreeBtn="关闭"
      :modalTitle="daoruTitle"
    >
      <div slot="content" style="text-align: left">
        <div class="daoru-addnew">
          <span>已新增 :</span>
          <span v-if="DaoruSuccese.newInsertNum == '导入中'">{{DaoruSuccese.newInsertNum}}</span>
          <span v-if="DaoruSuccese.newInsertNum >= 0">{{DaoruSuccese.newInsertNum}}条</span>
        </div>
        <div class="daoru-addnew" v-if="showRuleNum == 1">
          <span>已覆盖更新 :</span>
          <span v-if="DaoruSuccese.updateNum == '导入中'">{{DaoruSuccese.updateNum}}</span>
          <span v-if="DaoruSuccese.updateNum >= 0">{{DaoruSuccese.updateNum}}条</span>
        </div>
        <div class="daoru-addnew" v-if="showRuleNum == 2">
          <span>已跳过 :</span>
          <span v-if="DaoruSuccese.jumpNum == '导入中'">{{DaoruSuccese.jumpNum}}</span>
          <span v-if="DaoruSuccese.jumpNum >= 0">{{DaoruSuccese.jumpNum}}条</span>
        </div>
        <!-- <div class="daoru-addnew" v-if="showRuleNum == 2">
          <span>已成功处理 :</span>
          <span v-if="DaoruSuccese.successNum == '导入中'">{{DaoruSuccese.successNum}}</span>
          <span v-if="DaoruSuccese.successNum >= 0">{{DaoruSuccese.successNum}}条</span>
        </div> -->
        <!-- <div class="daoru-addnew" v-if="DaoruSuccese.jumpNum > 0">
          <span>已跳过 :</span>
          <span>{{DaoruSuccese.jumpNum}}条</span>
        </div> -->
        <div class="daoru-addnew">
          <span>错误 :</span>
          <span v-if="DaoruSuccese.failNum == '导入中'">{{DaoruSuccese.failNum}}</span>
          <span v-if="DaoruSuccese.failNum >= 0">{{DaoruSuccese.failNum}}条</span>
          <span
            v-if="DaoruSuccese.finished && DaoruSuccese.failNum > 0"
            style="color:#2D8CF0;cursor: pointer;"
            @click="upFail(DaoruSuccese.errorKey)"
          >点击下载错误数据</span>
        </div>
        <div class="daoru-addnew">
          <span>耗时 :</span>
          <span>{{DaoruSuccese.Time}}</span>
          <span v-if="DaoruSuccese.tryMathRemainTime">剩余时间:{{DaoruSuccese.tryMathRemainTime}}</span>
        </div>
        <div class="daoru-addnew" v-if="!DaoruSuccese.finished">
          <span style="color: #FF4D4F;">正在操作，请耐心等待，若操作意外中断，数据仍将继续导入。</span>
        </div>
        <div class="daoru-addnew" v-if="DaoruSuccese.finished && DaoruSuccese.errorMsg">
          <span style="color: #FF4D4F;">{{DaoruSuccese.errorMsg}}</span>
        </div>
        <div class="daoru-addnew daoru-progress">
          <el-progress :percentage="percenNum"  class="newPushInto-progress"></el-progress>
        </div>
        <div class="daoru-caozuoshuju">
          <span v-if="DaoruSuccese.totalNum >= 0">{{DaoruSuccese.finishNum + '/' +  DaoruSuccese.totalNum}}</span>
          <span v-if="DaoruSuccese.redisKey">{{'导入编号:'+ userInfo.tenant_id +  DaoruSuccese.redisKey}}</span>
        </div>
      </div>
    </new-task-modal>
  </div>
</template>

<script>
import { encrypt } from "@/router/encrypt.js";
import download from "@/api/downloadApp/download.js";
import { mapState } from "vuex";
import { toDaoRuData, uploadFile, daoruDown } from "@/api/Daoru/daoru";
export default {
  props: {
    identity: {
      type: String,
      default: ''
    },
    // 导入弹窗
    importModal: {
      type: Boolean,
      default: false
    },
    // 导入弹窗名
    modalTitle: {
      type: String,
      default: '导入学生数据'
    },
    // 模板下载提示
    downLoadNotice: {
      type: String,
      default: ''
    },
    //上传文件接口链接
    actionURL: {
      type: String
    },
    //上传文件所带的参数
    actionUplodeDate: {
      type: Object,
      default: null
    },
    //下载模板接口链接
    downloadURL: {
      type: String
    },
    //下载模板是否带参数
    isDownloadCS: {
      type: Boolean,
      default: false
    },
    //下载模板所带参数
    isBid: {
      type: String
    },
    //获取关系列表接口链接
    relationURL: {
      type: String
    },
    //确定导入接口链接
    DaoruURL: {
      type: String
    },
    //获取导入状况接口链接
    IngURL: {
      type: String
    },
    //下载导入错误数据接口链接
    upFailURL: {
      type: String
    },
    //是否是补充导入
    isSupplement: {
      type: Boolean,
      default: false
    },
    //获取检查字段接口
    inspectionsURL: {
      type: String,
      default: null
    },
    // 是否有重复规则
    needRepeat: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  data() {
    return {
      identityName:'',//导出文件名
      fileObjData:{},//上传的压缩包
      detailModal: false, // 字段匹配弹窗
      daoruOnlykey: "", //导入的唯一key值
      closeonclickmodal: false, //是否开启点击空白处关闭弹窗
      countNum: 1, //用于显示第一个错误
      fieldArr: [], //检查字段名列表
      ruleFormImport: {
        jbDesc: "1",
        fileList: [], // 文件列表
        isfile: "",
        isDaiMa: 1,
        gzRadio: 1, // 重复规则
        cwRadio: 1, // 错误规则
        namingRule: 1 ,//命名规则
        fieldGroup: [], // 检查字段
        fieldHasValue: 1, //字段已有值
      },
      rulesImport: {
        jbDesc: [{ required: true, message: "请输入标题行", trigger: "blur" }],
        isfile: [{ required: true, message: "请上传文件", trigger: "change" }],
        gzRadio: [
          { required: true, message: "请选择重复规则", trigger: "change" }
        ],
        namingRule: [
          { required: true, message: "请选择上传照片的命名规则", trigger: "change" }
        ],
        cwRadio: [
          { required: true, message: "请选择错误规则", trigger: "change" }
        ],
        fieldGroup: [
          { required: true, message: "请选择补充字段", trigger: "blur" }
        ],
        fieldHasValue: [
          { required: true, message: "请选择字段已有值", trigger: "change" },
        ],
        isDaiMa: [
          {
            required: true,
            message: "请选择是否有代码数据",
            trigger: "change",
          },
        ],
      },
      systematicList: [], //系统字段列表
      excelList: [], //excel表头列表
      relationList: [], //关系列表
      haveLast: true, //显示上一步按钮
      outputModal: false, // 导入最后数据确定弹窗
      uplodeDate: {
        //上传文件带的参数
        tenantId: this.$store.state.user.tenantId
      },
      daoruGuoCModal: false, //导入过程弹窗
      OnlyBtn: true, //导入过程弹框只有一个按钮
      guanbiDisabled: true, //导入过程弹框关闭按钮
      daoruTimer: null, //导入过程定时器
      IsDaoruTimes: 0, //导入过程计时
      percenNum: 0, //进度条进度数字
      DaoruSuccese: {
        errorData: [], //错误数据  暂存前端 下载错误数据时返回
        finished: false, // 是否完成导入
        failNum: "导入中", //失败数量
        newInsertNum: "导入中", //新增数量
        successNum: "导入中", //成功数量
        updateNum: "导入中", //覆盖数量
        Time: "导入中", //耗时
        totalNum: 0, // 总计需要操作次数
        finishNum: 0, // 当前操作次数
        jumpNum: "导入中", // 跳过数量
        errorKey: "" //错误数据
      }, //导入成功后的数据列表
      isOnly: "", //有检查字段显示主键
      isTS: "导入未完成", //导入弹框提示文字
      uploadFilter: ['.zip'],
      isClose: true,
      daoruTitle: '导入中',
      theClickBtn: true, // 点击导入按钮是否可用,
      userTenantId:10,
      showRuleNum:1,//重复规则
      showLoading: false//点击导入禁用按钮
    };
  },
  watch: {
    importModal: function() {
      if (this.importModal) {
        this.isClose = false
        // if (this.actionUplodeDate !== null) {
        //   this.uplodeDate = this.actionUplodeDate;
        //   if (this.isSupplement) {
        //     this.inspectionsSelect();
        //   }
        // debugger
        switch (this.identity) {
            case "NEW_STUDENT":
              this.ruleFormImport.namingRule = 1;
              break;
            case "STUDENT":
              this.ruleFormImport.namingRule = 1;
              break;
            case "GRADUATE_STUDENT":
              this.ruleFormImport.namingRule = 1;
              break;
            case "TEACHER":
              this.ruleFormImport.namingRule = 1;
              break;
            case "OTHER":
              this.ruleFormImport.namingRule = 3;
              break;
            default:
          }
        // }
      } else {
        this.isClose = true
      }
      // console.log(this.isClose)
      console.log("检测到改变", this.uplodeDate);
    }
  },
  methods: {
    //自定义上拆
    async goUplodOneImgZip(param) {
      console.log(param.file);
      this.fileObjData = param.file;
    },
    // 验证格式
    filterFileRes (testSuffix, uploadFilter) {
      let matchingCount = false
      uploadFilter.forEach(element => {
        // console.log(element)
        if (element === testSuffix) {
          matchingCount = true
        }
      })
      return matchingCount
    },
    //检查字段勾选时
    changeJC(val) {
      console.log("kankan检查字段", val);
    },
    // 上传失败
    handleError(err) {
      console.log(err)
      this.$message.error("只支持文件扩展名.zip");
    },
    uploadSectionFile(params) {
        // params.onProgress({percent: 0 })
      const file = params.file
      console.log(file)
      const  isLt5M = file.size / 1024 / 1024 <= 200;
    //   let testSuffix = file.name.substring(file.name.lastIndexOf('.'))
    //   console.log(testSuffix,'尾巴')
      let res = file.type === "application/x-zip-compressed";
      if (!res) {
        this.$message.error('上传文件格式错误')
        return (this.ruleFormImport.fileList = []);

      }
      if (!isLt5M) {
        this.$message.error("上传文件大小不得大于1G");
        return (this.ruleFormImport.fileList = []);
      }
      this.fileObjData = file;
    //   params.onProgress({percent: 100 })
       this.ruleFormImport.isfile = "1";
    //   const form = new FormData();
    //   // 文件对象
    //   form.append("file", file);
    //   if (this.actionUplodeDate !== null) {
    //     form.append("tenantId", this.userTenantId);
    //     console.log("id", this.uplodeDate.id);
    //     form.append("id", this.uplodeDate.id);
    //   } else {
    //     form.append("tenantId", this.userTenantId);
    //   }
    //   if(this.isSupplement) {
    //     form.append("type", '2');
    //   }else{
    //     form.append("type", '1');
    //   }
    //   uploadFile(this.actionURL, form)
    //     .then(res => {
    //       console.log(res, '上传结果')
    //       const code = res && parseInt(res.status, 10);
    //       if (code === 200) {
    //         this.ruleFormImport.isfile = "1";
    //       } else {
    //         this.$message.error(res.data.msg);
    //         this.ruleFormImport.fileList = [];
    //       }
    //     })
    //     .catch(err => {
    //       this.ruleFormImport.fileList = [];
    //       this.$message.error(err);
    //     });
    },
    //表单验证规则
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //提交表单
    commn(formName) {
      this.countNum = 0;
      console.log("commnnnnn", this.ruleFormImport.fileList);
      this.$nextTick(() => {
        if (formName == "ruleFormOut") {
          return this.daoru();
        } else {
          // debugger
          this.$refs[formName].validate(valid => {
            console.log("valid222222211212", valid);
            if (valid) {
              this.countNum = 1;
              // if (formName == "ruleForm") {
              //   this.detailModal = true;
              //   return this.selecTrelationList();
              //   //  this.daoru();
              // }
              this.showLoading=true;
              this.daoru();
            } else {
              this.theClickBtn = true
              return false;
            }
          });
        }
      });
    },
    // 取消导入
    closeImport() {
      (this.ruleFormImport = {
        jbDesc: "1",
        fileList: [], // 文件列表
        isfile: "",
        isDaiMa: 1,
        gzRadio: 1, // 重复规则
        cwRadio: 1, // 错误规则
        namingRule: 1,
        fieldGroup: [], // 检查字段
        fieldHasValue: 1, //字段已有值
      }),
      // this.$refs.ruleForm.resetFields();
      // this.$refs.ruleFormOut.resetFields();
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields();
        // this.$refs.ruleFormOut.resetFields();
      });
      this.$refs.upload.clearFiles();
      this.ruleFormImport.fieldGroup = [];
      this.systematicList = [];
      this.excelList = [];
      this.relationList = [];
      this.fieldArr = [];
      this.isOnly = "";
      this.$emit("closeNewTask");
      this.theClickBtn = true;
      this.showLoading = false;
      console.log("取消导入", this.fieldArr);
    },
    // 下一步
    nextStep() {
      // this.$emit('closeNewTask');
      // this.detailModal = true;
        this.theClickBtn = true;
        this.commn("ruleForm");
      // this.selecTrelationList();
    },
    //字段映射上一步
    LastTask() {
      this.systematicList = [];
      this.excelList = [];
      this.relationList = [];
      this.detailModal = false;
    },
    // 导入最后数据确定上一步
    LastTask2() {
      this.outputModal = false;
    },
    //导入    点击文件列表中已上传的文件时的钩子
    handlePreview(file) {
      console.log(file);
    },
    //导入  文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    //导入   删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止删除。
    beforeRemove(file, fileList) {
      console.log(fileList);
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSuccess() {
      this.ruleFormImport.isfile = "1";
    },
    //导入   文件超出个数限制时的钩子
    handleExceed (files) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
        files.length
        } 个文件，请删除原有上传文件后再上传新的文件。`
      );
    },
    // 关闭字段匹配
    closeDetail() {
      this.theClickBtn = true;
      this.detailModal = false;
    },
    // 下一步字段匹配
    agreeDetail() {
      var isNOTGO = false;
      this.systematicList.forEach(sys => {
        if (sys.is_must == 1) {
          isNOTGO = true;
        }
      });
      if (isNOTGO) {
        this.$message.error("请匹配所有系统必填字段");
      } else {
        this.outputModal = true;
        this.ruleFormOutPut = this.ruleFormImport;
      }
    },
    // 关闭 导入最后数据确定
    closeOutPut() {
      this.outputModal = false;
      console.log("取消导入", this.fieldArr);
    },
    //确定导入
    isdaoru() {
      var isNOTGO = false;
      this.systematicList.forEach(sys => {
        if (sys.is_must == 1) {
          isNOTGO = true;
        }
      });
      if (isNOTGO) {
        this.$message.error("请匹配所有系统必填字段");
      } else {
        this.commn("ruleFormOut");
      }
    },
    async daoru() {
      try {

        this.guanbiDisabled = true;
        const url = this.DaoruURL;
        console.log("urlllll", url);
        console.log("identity", this.identity,this.ruleFormImport.gzRadio,this.ruleFormImport.cwRadio);
        // let params = {};
        let dataa = {
          tenantId: this.userTenantId,
          identity: this.identity,
          repeatRule: this.ruleFormImport.gzRadio,
          errorRule: this.ruleFormImport.cwRadio,
          namingRule: this.ruleFormImport.namingRule,
        };
        // FormData 对象
        let form = new FormData();
        // 文件对象
        form.append("uploadZip", this.fileObjData);
        form.append("data", encrypt(dataa));
        console.log(form,"form",dataa,1111111111111111111,this.fileObjData);
        // let {
        //   data
        // } = await this.$store.dispatch("importFaceImages", form)
        //   // const data = res.data;
        //   console.log("这是关系列表获取接口", data);
        //   if (data.status === 1000) {
        //     this.daoruOnlykey = data.result.redisKey;
        //     this.$emit("closeNewTask");
        //     this.detailModal = false;
        //     this.outputModal = false;
        //     this.daoruGuoCModal = true;
        //     //清空定时器
        //     clearInterval(this.daoruTimer);
        //     this.daoruTimer = null;
        //     this.IsDaoruTimes = 0;
        //     //开启定时器
        //     this.getTime();
        //   } else if (data.status === 1002) {
        //     this.$message.error(data.msg);
        //     this.closeOutPut();
        //     //清空定时器
        //     clearInterval(this.daoruTimer);
        //     this.daoruTimer = null;
        //     this.IsDaoruTimes = 0;
        //   } else {
        //     this.$message.error(data.msg);
        //   }
        //   this.theClickBtn = true;
        this.showRuleNum=this.ruleFormImport.gzRadio
        uploadFile(url, form)
        .then(res => {
            console.log("这是关系列表获取接口", res);
            // return
          if (res.data.status === 1000) {
            this.daoruOnlykey = res.data.result.redisKey;
            this.$emit("closeNewTask");
            this.detailModal = false;
            this.outputModal = false;
            this.daoruGuoCModal = true;
            //清空定时器
            clearInterval(this.daoruTimer);
            this.daoruTimer = null;
            this.IsDaoruTimes = 0;
            //开启定时器
            this.getTime();
          } else if (res.data.status === 1002) {
            this.$message.error(res.data.msg);
            this.closeOutPut();
            //清空定时器
            clearInterval(this.daoruTimer);
            this.daoruTimer = null;
            this.IsDaoruTimes = 0;
          } else {
            this.$message.error(res.data.msg);
          }
          this.theClickBtn = true;
           this.showLoading=false
        })
        .catch(err => {
        //   this.ruleFormImport.fileList = [];
          this.$message.error(err);
        });
      } catch (err) {
        console.log(err);
      }
    },
    //下载模板
    downloadExcel(val) {
      console.log("valllllll", val);
      if (this.isDownloadCS) {
        try {
          const url = val;
          console.log("urlllll", url);
          const params = {
            id: this.isBid, //表id
            tenantId: this.userTenantId
          };
          console.log("params", params);
          this.$downLoadFile(url, params);
        } catch (err) {
          console.log(err);
        }
      } else {
        console.log("valllllll", val);
        this.$downLoadFile(val);
      }
    },
    //获取字段匹配
    selecTrelationList() {
      try {
        const url = this.relationURL;
        console.log("urlllll", url);
        let params = {};
        if (this.actionUplodeDate !== null) {
          params = {
            tenantId: this.userTenantId,
            type: this.isSupplement? '2' : '1',
            id: this.uplodeDate.id
          };
        } else {
          params = {
            tenantId: this.userTenantId
          };
        }
        toDaoRuData(url, params).then(res => {
          const data = res.data;
          console.log("这是关系列表获取接口", data);
          if (data.status === 1000) {
            this.relationList = data.result.matchFieldList;
            //遍历对比已匹配的系统字段，并保留未匹配的
            var sysisNot = false;
            data.result.dbFieldList.forEach(sys => {
              this.relationList.forEach(rel => {
                if (sys.column == rel.column || (sys.column == 'campusName' || sys.column == 'campusId'|| sys.column == 'collegeId'|| sys.column == 'collegeName'|| sys.column =="majorId" || sys.column == "majorName" || sys.column == "classId" || sys.column == "className")) {
                  sysisNot = true;
                }
              });
              if (!sysisNot) {
                console.log("inNottttttt", sysisNot);
                this.systematicList.push(sys);
              } else {
                sysisNot = false;
              }
            });
            console.log("systematicList", this.systematicList);
            //遍历对比已匹配的excel表头，并保留未匹配的
            var excisNot = false;
            data.result.excelField.forEach(exc => {
              this.relationList.forEach(rel => {
                if (exc == rel.configure) {
                  excisNot = true;
                }
              });
              if (!excisNot) {
                console.log("inNottttttt", excisNot);
                this.excelList.push(exc);
              } else {
                excisNot = false;
              }
            });
            console.log("excelList", this.excelList);
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //轮询状态请求查询导入状况
    daoruIng() {
      // debugger
      try {
        const url = this.IngURL;
        console.log("urlllll", url);
        let params = {};
        if (this.actionUplodeDate !== null) {
          params = {
            tenantId: this.userTenantId,
            id: this.uplodeDate.id,
            key: this.daoruOnlykey
          };
        } else {
          params = {
            tenantId: this.userTenantId,
            redisKey: this.daoruOnlykey
          };
        }
        toDaoRuData(url, params).then(res => {
          const data = res.data;
          console.log("这是轮询状态请求查询导入状况接口", data);
          if (data.status === 1000) {
            // 没有结果的情况
            if (data.result === "null") {
              return
            }
            // 没有完成导入的情况
            let asyncTask = data.result
            this.percenNum = new Number((asyncTask.finishRate * 100).toFixed(2))
            this.DaoruSuccese = Object.assign(this.DaoruSuccese,
            asyncTask)
            // 没有结束的时候 时间需要手动计算
            // this.DaoruSuccese.Time = ((new Date() - new Date(asyncTask.startTime))/1000).toFixed(2)
            this.DaoruSuccese.Time = asyncTask.useTimeStr
            if (asyncTask.finished == true) {
              clearInterval(this.daoruTimer);
              this.daoruTimer = null;
              // this.DaoruSuccese.Time = asyncTask.useTime;
              console.log("DaoruSuccese", this.DaoruSuccese);
              this.IsDaoruTimes = 0;
              this.percenNum = 100;
              this.guanbiDisabled = false;
              this.daoruTitle = '导入成功'
              this.isTS = "导入完成";
              if (this.isTS !== "导入完成") {
                this.$message.error(this.isTS);
              } else {
                this.$message.success(this.isTS);
              }
            }
          } else if (data.status === 8010) {
            // 网络超时终端，不进行处理
            return
          } else {
            this.daoruTitle = '导入失败'
            console.error('导入情况获取失败 导入数据：' + JSON.stringify(data))
            clearInterval(this.daoruTimer);
            this.daoruTimer = null;
            this.isTS = "操作失败";
            if (this.isTS !== "导入完成") {
              this.$message.error(this.isTS);
            } else {
              this.$message.success(this.isTS);
            }
            this.isdaoruGuoC();
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //查询导入状况定时器
    getTime() {
      this.daoruTimer = setInterval(() => {
        this.IsDaoruTimes = this.IsDaoruTimes + 3;
        this.daoruIng();
      }, 3000);
    },
    //下载错误数据
    //下载错误数据
    upFail () {
      try {
        const url = this.upFailURL;
        console.log("urlllll", url);
        // const dat = {
        //   tenantId: this.userTenantId
        // };
        let dat = {};
        if (this.actionUplodeDate !== null) {
          dat = {
            tenantId:this.userTenantId,
            id: this.uplodeDate.id,
            errorKey: this.DaoruSuccese.errorKey //下载错误数据带的参数
          };
        } else {
          dat = {
            tenantId: this.userTenantId,
            errorKey: this.DaoruSuccese.errorKey, //下载错误数据带的参数
            identity:this.identity
          };
        }
        daoruDown(url, dat).then(res => {
          const data = res;
          console.log(data);
        //   debugger
          if (this.actionUplodeDate !== null) {
            window.open(
              url +
              "?tenantId=" +
              this.userTenantId +
              "&id=" +
              this.uplodeDate.id +
              "&errorKey=" +
              this.DaoruSuccese.errorKey
            );
          } else {
            window.open(
              url +
              "?tenantId=" +
              this.userTenantId +
              "&errorKey=" +
              this.DaoruSuccese.errorKey+
              "&identity=" +
              this.identity
            );
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    // async upFail(Key) {
    //  let aaa = this.identity
    //   switch (aaa) {
    //       case "NEW_STUDENT":
    //           this.identityName = "导入照片-新生的错误数据";
    //           break;
    //       case "GRADUATE_STUDENT":
    //           this.identityName = "导入照片-毕业生的错误数据";
    //           break;
    //       case "STUDENT":
    //           this.identityName = "导入照片-在校生的错误数据";
    //           break;
    //       case "OTHER":
    //           this.identityName = "导入照片-其他用户的错误数据";
    //           break;
    //       case "TEACHER":
    //           this.identityName = "导入照片-教工的错误数据";
    //           break;
    //   }
    //   try {
    //         toDaoRuData(this.upFailURL, {
    //             errorKey: Key,
    //             tenantId:this.userTenantId
    //         })
    //     .then(downExcel => {
    //       console.log(downExcel, '下载错误数据结果')
    //      download(downExcel.data, this.identityName + ".xlsx");
    //      this.outputModalImg = false;
    //     })
    //     .catch(err => {
    //       this.ruleFormImport.fileList = [];
    //       this.$message.error(err);
    //     });
    //     // const downExcel = await this.$store.dispatch("errorResport", {
    //     //   errorKey: Key,
    //     // });
    //     // console.log(downExcel);
    //     // download(downExcel.data, this.identityName + ".xlsx");
    //     // this.outputModalImg = false;
    //   } catch (error) {
    //     console.log("error", error);
    //     this.$message.error("导出失败");
    //   }
    // },
    //关闭导入过程弹框
    isdaoruGuoC() {
      clearInterval(this.daoruTimer);
      this.daoruTimer = null;
      (this.ruleFormImport = {
        jbDesc: "1",
        fileList: [], // 文件列表
        isfile: "",
        isDaiMa: 1,
        gzRadio: 1, // 重复规则
        cwRadio: 1, // 错误规则
        namingRule: 1 ,
        fieldGroup: [], // 检查字段
        fieldHasValue: 1, //字段已有值
      }),
      this.$refs.ruleForm.resetFields();
      this.$refs.upload.clearFiles();
      this.systematicList = [];
      this.excelList = [];
      this.relationList = [];
      this.fieldArr = [];
      this.isOnly = "";
      this.daoruTitle = '导入中'
      this.DaoruSuccese = {
        errorData: [], //错误数据  暂存前端 下载错误数据时返回
        failNum: "导入中", //失败数量
        newInsertNum: "导入中", //新增数量
        successNum: "导入中", //成功数量
        updateNum: "导入中", //覆盖数量
        jumpNum: "导入中", //跳过数量
        Time: "导入中" //耗时
      };
      this.percenNum = 0;
      this.daoruGuoCModal = false;
      this.$emit("daoruSuccess");
    },
    //获取检查字段
    inspectionsSelect() {
      try {
        const url = this.inspectionsURL;
        console.log("urlllll", url);
        this.fieldArr = []
        if (url) {
          toAddData(url).then(res => {
            const data = res.data;
            console.log("这是补充字段", data.result);
            // let arr = JSON.stringify(data.result).replace(/^{|}$/g, '').split(',')
            // console.log("这是补充字段String", arr);

            if (data.status === 1000) {
              let addRes = data.result;
              // const mapData = new Map(Object.entries(addRes))
              addRes.forEach(el => {
                let obj = {}
                if (!(el.value == 'campusName' || el.value == 'campusId'|| el.value == 'collegeId'|| el.value == 'collegeName'|| el.value =="majorId" || el.value == "majorName" || el.value == "classId" || el.value == "className")) {
                  obj.fieldName = el.value
                  obj.fieldNote = el.key
                  this.fieldArr.push(obj)
                }
              })
              // for (const key in addRes) {
              //   let obj = {}
              //   obj.fieldName = addRes[key]
              //   obj.fieldNote = key
              //   this.fieldArr.push(obj)
              // }
            } else {
              this.$message.error(data.msg)
            }
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    //有检查字段的情况下选择允许重复数据
    chickCF(val) {
      if (val == 3) {
        let arrJC = [];
        this.fieldArr.forEach(element => {
          if (element.isKey == 1) {
            arrJC.push(element.fieldNote);
          }
        });
        this.isOnly = arrJC.join("，");
      }
    }
  },
  created() {
    this.uplodeDate.tenantId = this.userInfo.tenant_id;
    this.userTenantId = this.userInfo.tenant_id;
  }
};
</script>

<style lang="scss">
.pushInto {
  .newPushInto-progress {
    .el-progress-bar {
      padding-right: 60px;
      margin-right: -65px;
    }
  }
  .new-transfer-modal {
    .el-dialog__body {
      height: 369px;
      overflow-y: hidden;
    }
  }
  .ziduan {
    .el-form-item__content {
      margin-left: 0px !important;
    }
  }
  .jichu-title {
    width: 72px;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFangSC;
    font-weight: 600;
    color: rgba(48, 66, 88, 1);
    line-height: 17px;
  }
  .daoru-addnew {
    height: 28px;
    line-height: 28px;
    margin-top: 16px;
    span {
      margin-right: 8px;
    }
  }
  .daoru-caozuoshuju {
    height: 12px;
    line-height: 12px;
    font-size: 12px;
    color: #aeaeb4;
    span {
      margin-right: 8px;
    }
  }
  .daoru-progress {
    .el-progress-bar {
      padding-right:65px;
      margin-right:-65px;
    }
  }
  .push-notice {
    // padding-top: 14px;
    padding-left: 84px;
    color: #aeaeb4;
    line-height: 28px;
    font-size: 12px;
  }
}
</style>
